import React from 'react';
import { translate } from '../Services/translation';

const CreateBusinessCard = ({
    showInfo,
    toggle,
    addDynamicProductToCart
}) => (
    <div className="create_business_card create_business_card--offcanvas">       
            <div className={`create_business_card__info${!showInfo ? ' create_business_card__info--hidden' : ''}`}>
                <button onClick={() => addDynamicProductToCart()} className="business-card-buy-button product-detail__buy-button">
                    {translate('adddynamicproducttocart.button')}
                </button>
                {/*<button onClick={() => generateBusinessCard()} className="product__buy-button create_business_card__button--export">
                    <i className="fas fa-file-pdf"></i>
                    {translate('genericexport.exportpdf.button')}
                </button>*/}
            </div>
        </div>
)

export default CreateBusinessCard;